import { render, staticRenderFns } from "./dubletten-confirmation-table.vue?vue&type=template&id=007ca8fa&scoped=true"
import script from "./dubletten-confirmation-table.vue?vue&type=script&lang=js"
export * from "./dubletten-confirmation-table.vue?vue&type=script&lang=js"
import style0 from "./dubletten-confirmation-table.vue?vue&type=style&index=0&id=007ca8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ca8fa",
  null
  
)

export default component.exports